import React, { useEffect, useState } from "react";
import CommonForm from "../../../../../../components/commonform/commonForm";
import { EmailValidate } from "../../../../../../components/formValidate";
import Snackbar from "../../../../../../components/snackbar/snackbar";
import { is_email_registered } from "../../../../user.api";
import moment from "moment";

// import { user_area_types_list, user_locations_list } from "../../../user.api";

let area_management = [{ id: "1" }, { id: "2" }, { id: "3" }];
export default function AreaDetails(props) {
  const [formData, setFormData] = useState(props.formData);
  const [keyvalue, setKeyvalue] = useState(0);
  const [count, setCount] = useState(1);
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];

  const monthIndex = moment().month(); // 0-based, Apr=3
  const fyStart = monthIndex >= 3 ? currentYear : currentYear - 1;
  const currentFY = `${fyStart}-${fyStart + 1}`;

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      financial_year:
        prev?.financial_year || (financialYears.includes(currentFY) ? currentFY : "2025-2026"),
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFormData(props.formData);
  }, [props.formData]);
  const handleNextSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (props.update) {
      let isValidDate = false;

      isValidDate = moment(formData.registration_date, "DD-MM-YYYY").isValid();

      // console.log(new Date(formData.file_registration_proof));

      if (
        formData.file_registration_proof !== null &&
        formData.file_registration_proof !== undefined &&
        formData.file_registration_proof !== ""
      ) {
        if (
          formData.file_submitted_record !== null &&
          formData.file_submitted_record !== undefined &&
          formData.file_submitted_record !== ""
        ) {
          if (
            formData.registration_date !== null &&
            formData.registration_date !== undefined &&
            formData.registration_date !== "" &&
            isValidDate &&
            formData.registration_date !== "00-00-0000" &&
            formData.registration_date !== "30-11--1"
          ) {
            if (!formData.declaration_truth || !formData.declaration_promo) {
              setSnackOpen(true);
              setSnackMessage("Please accept both declarations to proceed");
              setIsSnackError(true);
              return;
            }
            props.action(0, formData);
          } else {
            setSnackOpen(true);
            setSnackMessage("Please choose a valid registration date");
            setIsSnackError(true);
          }
        } else {
          setSnackOpen(true);
          setSnackMessage("Please choose a valid request letter");
          setIsSnackError(true);
        }
      } else {
        setSnackOpen(true);
        setSnackMessage("Please choose a valid registration proof");
        setIsSnackError(true);
      }
    } else {
      let emailData = { email: formData.email };

      is_email_registered(emailData)
        .then((res) => {
          // setSnackMessage(res.message);
          // setIsSnackError(false);
          // setIsActive(false);
          let isValidDate = false;

          isValidDate = moment(
            formData.registration_date,
            "DD-MM-YYYY"
          ).isValid();

          // console.log(new Date(formData.file_registration_proof));

          if (
            formData.file_registration_proof !== null &&
            formData.file_registration_proof !== undefined &&
            formData.file_registration_proof !== ""
          ) {
            if (
              formData.file_submitted_record !== null &&
              formData.file_submitted_record !== undefined &&
              formData.file_submitted_record !== ""
            ) {
              if (emailRegex.test(formData?.email) === true) {
                if (!formData.declaration_truth || !formData.declaration_promo) {
                  setSnackOpen(true);
                  setSnackMessage("Please accept both declarations to proceed");
                  setIsSnackError(true);
                  return;
                }
                props.action(0, formData);
              } else {
                setSnackOpen(true);
                setSnackMessage("Please enter a valid email");
                setIsSnackError(true);
              }
            } else {
              setSnackOpen(true);
              setSnackMessage("Please choose a valid request letter");
              setIsSnackError(true);
            }
          } else {
            setSnackOpen(true);
            setSnackMessage("Please choose a valid registration proof");
            setIsSnackError(true);
          }
          // setSnackOpen(true);
        })
        .catch((error) => {
          setSnackMessage(error.response.data.message);
          setIsSnackError(true);
          setSnackOpen(true);
          // setIsActive(false);
        });
    }
    // props.action(0, formData);
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    // if (!flag) {
    //   handleEventList();
    // }
  };
  const handleCourseChange = (e, i) => {
    let data = { ...formData };

    data.course_details[i] = {
      ...data.course_details[i],
      [e.target.name]: e.target.value,
    };

    setFormData(data);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const addCourse = (i) => {
    let data = { ...formData };

    data.course_details.push({
      course_name: "",
      course_type: "Technical",
    });
    setFormData(data);
    setCount(count + 1);
  };
  const removeCourse = (i) => {
    let data = { ...formData };
    data.course_details.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };

  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    let name = e.target.name;

    let value = e.target.value;
    let data = formData;
    data[name] = value;
    // Compose combined fields for backend compatibility
    if (
      name === "authorized_person_name" ||
      name === "authorized_person_designation" ||
      name === "email"
    ) {
      const personName = name === "authorized_person_name" ? value : data.authorized_person_name;
      const personDesignation =
        name === "authorized_person_designation" ? value : data.authorized_person_designation;
      const mail = name === "email" ? value : data.email;
      const phone = data.phone_number;
      data["contact_person_details"] = `Name: ${personName ?? ""} | Designation: ${personDesignation ?? ""} | Phone: ${phone ?? ""} | Email: ${mail ?? ""}`;
    }
    if (name === "affiliation_details" || name === "affiliation_number") {
      const details = name === "affiliation_details" ? value : data.affiliation_details;
      const number = name === "affiliation_number" ? value : data.affiliation_number;
      data["affiliation"] = `${details ?? ""}${number ? ` | Affiliation No: ${number}` : ""}`;
    }
    setFormData(data);
    setKeyvalue(keyvalue + 1);
  };
  // const handleNumberChange = (e) => {

  //   let name = e.target.name;
  //   let value = e.target.value;
  //   let newValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  //   let data = formData;
  //   data[name] = newValue;
  //   setFormData(data);
  //   setKeyvalue(keyvalue + 1);
  // };
  const handleNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setFormData(data);
  };
  const handleDatePickerChange = (e, name) => {
    let date = e.value;

    console.log(date);
    if (date) {
      setFormData({ ...formData, [name]: date });
      setKeyvalue(keyvalue + 1);
    } else {
      setFormData({ ...formData, [name]: null });

      setKeyvalue(keyvalue + 1);
    }
  };
  const handleFileChange = (e) => {
    let size = e.target.files[0].size;
    let fileName =
      e.target.name === "file_registration_proof"
        ? "file_name_proof"
        : "file_name_request";

    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "pdf"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 1) {
        setFormData({
          ...formData,
          [fileName]: e.target.files[0].name,
          [e.target.name]: e.target.files[0],
        });
      } else {
        setSnackMessage("File size is greater than 1MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData({
          ...formData,
          [fileName]: null,
          [e.target.name]: null,
        });
      }
    } else {
      setSnackMessage("File should be in .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
      setFormData({
        ...formData,
        [fileName]: null,
        [e.target.name]: null,
      });
    }
  };

  const handleImgFileChange = (e) => {
    let size = e.target.files[0].size;
    let type = e.target.files[0].name.split(".").pop();

    if (
      type?.toLowerCase() === "jpg" ||
      type?.toLowerCase() === "jpeg" ||
      type?.toLowerCase() === "png"
    ) {
      let mb = size / Math.pow(1024, 2);

      if (mb < 5) {
        setFormData({
          ...formData,
          logo_name: e.target.files[0].name,
          logo: e.target.files[0],

          // [e.target.name]: e.target.files[0],
        });
        // if (props.update) {
        //   props.handlefile();
        // }
      } else {
        setSnackMessage("File size is greater than 5MB");
        setIsSnackError(true);
        setSnackOpen(true);
        setFormData({
          ...formData,
          logo: null,
          [e.target.name]: null,
        });
      }
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png format");
      setIsSnackError(true);
      setSnackOpen(true);
      setFormData({
        ...formData,
        logo: null,
        [e.target.name]: null,
      });
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the selected financial year
    }));
  };


  console.log(formData);
  return (
    <div className="expert ">
      <form onSubmit={handleNextSubmit} className="">
        {/* Institution Details */}
        <div className="form-section">
          <div className="section-header">
            <h4 className="section-title">Institution Details</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="text"
              label="Name of the Institution"
              required
              name="institution_name"
              value={formData.institution_name ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="multiline"
              label="Registered Office Address"
              required
              name="address"
              value={formData.address ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="multiline"
              label="Headquarters Details"
              required
              name="headquaters_detail"
              value={formData.headquaters_detail ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="file"
              required={!formData.logo_name ? false : false}
              name="logo"
              {...props}
              id="logo"
              fileName={formData.logo_name}
              label="Upload Institution Logo"
              accept=".jpg,.jpeg,.png"
              type="file"
              variant="outlined"
              onChange={handleImgFileChange}
              className={"mb-2"}
            />
          </div>
        </div>

        {/* Contact Information */}
        <div className="form-section">
          <div className="section-header">
            <h4 className="section-title">Contact Information</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="text"
              label="Name of Authorized Person"
              required
              name="authorized_person_name"
              value={formData.authorized_person_name ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Designation of Authorized Person"
              required
              name="authorized_person_designation"
              value={formData.authorized_person_designation ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Contact Number"
              required
              disabled
              name="phone_number"
              value={formData.phone_number ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="email"
              label="Email ID"
              disabled={props.update}
              value={formData?.email ?? ""}
              onChange={textFieldChange}
              required
              name="email"
              {...props}
            />

            <label className="control-label mylabel mb-2">Alternate Contact Number</label>
            <div className="d-flex col-12 align-items-end ">
              <div className="col-1 ">
                <CommonForm
                  fieldType="text"
                  error={error.country_code}
                  name="country_code"
                  maxLength="4"
                  value={formData.country_code ?? ""}
                  onChange={handleNumberChange}
                  {...props}
                />
              </div>
              <div className="p-1"></div>
              <div className="col-11">
                <CommonForm
                  fieldType="text"
                  error={error.alternate_phone}
                  name="alternate_phone"
                  maxLength="10"
                  value={formData.alternate_phone ?? ""}
                  onChange={handleNumberChange}
                  {...props}
                />
              </div>
            </div>

            <CommonForm
              fieldType="email"
              label="Alternate Email ID"
              name="alternate_email"
              value={formData.alternate_email ?? ""}
              onChange={textFieldChange}
              {...props}
            />
          </div>
        </div>

        {/* Academic Information */}
        <div className="form-section">
          <div className="section-header">
            <h4 className="section-title">Academic Information</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="multiline"
              label="Affiliation Details"
              required
              name="affiliation_details"
              value={formData.affiliation_details ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Affiliation Number"
              required
              name="affiliation_number"
              value={formData.affiliation_number ?? ""}
              onChange={textFieldChange}
              {...props}
            />

            <CommonForm
              fieldType="file"
              required={!formData.file_name_proof ? true : false}
              label="Upload Proof of Affiliation/Registration"
              name="file_registration_proof"
              {...props}
              id="upload_proposal"
              fileName={formData.file_name_proof}
              className="no-margin"
              accept=".pdf"
              type="file"
              variant="outlined"
              onChange={handleFileChange}
            />
            <div className="file-up-helper ">
              *Upload only .pdf format and Size should be less than 1MB
            </div>

            <div className="mb-3">
              <label className="control-label mylabel mb-2">Academic Year</label>
              <select
                className="form-select mandatory-select"
                aria-label="Select Academic Year"
                name="financial_year"
                required
                value={formData.financial_year ?? ""}
                onChange={handleChange}
              >
                <option value="">Select Academic Year</option>
                {financialYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <CommonForm
              fieldType="text"
              label="Total Number of Students"
              required
              name="total_students"
              value={formData.total_students ?? ""}
              onChange={handleNumberChange}
              {...props}
            />

            <div className="header-label">Courses Offered</div>
            {formData.course_details?.map((e, i) => (
              <div className="section-datas-cont mb-3" key={i}>
                <div className="section-Cont ">
                  <div className="row pb-3">
                    <div className="col-xs-5 col-sm-6 mt-2">
                      <div className=" input-group">
                        <label className={"control-label mylabel mb-2"}>
                          Course Type
                        </label>
                      </div>
                      <select
                        id="course_type"
                        className="mandatory-select form-select selectbox w-100"
                        required
                        name="course_type"
                        onChange={(e) => handleCourseChange(e, i)}
                        value={e?.course_type ?? ""}
                      >
                        <option value="Technical">Technical</option>
                        <option value="Non-Technical">Non-Technical</option>
                      </select>
                    </div>
                    <div className="col-xs-6 col-sm-6 mt-2">
                      <div className=" input-group">
                        <label className={"control-label mylabel mb-2"}>
                          Course
                        </label>
                      </div>
                      <select
                        id="course_name"
                        className="mandatory-select form-select selectbox w-100"
                        required
                        name="course_name"
                        onChange={(e) => handleCourseChange(e, i)}
                        value={e?.course_name ?? ""}
                      >
                        {e.course_type === "Technical" ? (
                          <>
                            <option value="">Select Course</option>
                            <option value="ITI">ITI</option>
                            <option value="Diploma">Diploma</option>
                            <option value="Graduation">Graduation</option>
                            <option value="Post-Graduation">Post-Graduation</option>
                            <option value="MPhil">MPhil</option>
                            <option value="PhD">PhD</option>
                          </>
                        ) : e.course_type === "Non-Technical" ? (
                          <>
                            <option value="">Select Course</option>
                            <option value="12th">12th</option>
                            <option value="Graduation">Graduation</option>
                            <option value="Post-Graduation">Post-Graduation</option>
                            <option value="MPhil">MPhil</option>
                            <option value="PhD">PhD</option>
                          </>
                        ) : (
                          <option value="">Select Course Type</option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="more-btn-cnt">
                  {formData.course_details.length === i + 1 && (
                    <button
                      style={{ marginLeft: 5 }}
                      type="button"
                      {...props}
                      className="btn btn-primary"
                      onClick={(e) => addCourse(i)}
                    >
                      Add More
                    </button>
                  )}
                  {formData.course_details.length > 1 && (
                    <button
                      {...props}
                      type="button"
                      className="btn btn-primary"
                      onClick={(e) => removeCourse(i)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Institution Profile */}
        <div className="form-section">
          <div className="section-header">
            <h4 className="section-title">Institution Profile</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="multiline"
              label="Brief Note on Institution Activities"
              required
              value={formData.notes_institutions ?? ""}
              className="no-margin"
              name="notes_institutions"
              onChange={textFieldChange}
              {...props}
            />
          </div>
        </div>

        {/* Document Upload */}
        <div className="form-section">
          <div className="section-header">
            <h4 className="section-title">Document Upload</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="file"
              required={!formData.file_name_request ? true : false}
              label="Upload Request Letter on Institution Letterhead (signed by Head/Authorized Signatory) (PDF only)"
              name="file_submitted_record"
              {...props}
              id="file_submitted_record"
              accept=".pdf"
              type="file"
              variant="outlined"
              fileName={formData.file_name_request}
              onChange={handleFileChange}
            />
            <div className="file-up-helper">
              *Upload only .pdf format and Size should be less than 1MB
            </div>
          </div>
        </div>

        {/* Declaration & Submit */}
        <div className="form-section">
          <div className="section-header">
            <h4 className="section-title">Declaration & Submit</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="checkbox"
              name="declaration_truth"
              checked={!!formData.declaration_truth}
              onChange={handleCheckboxChange}
              label="I hereby, declare that the entries made by me in the form are complete and true to the best of my knowledge and based on records."
              {...props}
            />
            <CommonForm
              fieldType="checkbox"
              name="declaration_promo"
              checked={!!formData.declaration_promo}
              onChange={handleCheckboxChange}
              label="I hereby agree to use the institution’s name & logo in the promotional activities of Kerala Spacepark."
              {...props}
            />
          </div>
        </div>

        <div className="footer-buttons ">
          <button type="submit" className="primary-btn ">
            SUBMIT TO PREVIEW
          </button>
        </div>
      </form>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
